import Loader from '../../Loader';

function LarAppLoader() {
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader />
    </div>
  );
}
export default LarAppLoader;
